import { render, staticRenderFns } from "./ShopProfile.vue?vue&type=template&id=31eab864&scoped=true"
import script from "./ShopProfile.vue?vue&type=script&lang=js"
export * from "./ShopProfile.vue?vue&type=script&lang=js"
import style0 from "./ShopProfile.vue?vue&type=style&index=0&id=31eab864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eab864",
  null
  
)

export default component.exports